import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";

import useAuth from "../../../hooks/useAuth";
import { menuItems } from "./menuConfig";

// Bottom navigation mobile (<900px, breakpoint `md`): só Nível 1 fica
// sempre visível; "Mais" abre um Drawer com Nível 2 + Nível 3 juntos,
// sem sub-agrupamento visual (Design Notes da spec-fase-1-tema-shell.md).
const BottomNav = () => {
  const { permissoes } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [maisAberto, setMaisAberto] = React.useState(false);

  const itemsPermitidos = menuItems.filter((item) =>
    permissoes.some((permissao) => permissao.name === item.path),
  );
  const tier1 = itemsPermitidos.filter((item) => item.tier === 1);
  const outrosItems = itemsPermitidos.filter((item) => item.tier !== 1);

  const currentPath = location.pathname.replace("/", "");
  const tier1Ativo = tier1.some((item) => item.path === currentPath);
  const outrosAtivo = outrosItems.some((item) => item.path === currentPath);

  const handleNavigate = (path) => {
    setMaisAberto(false);
    navigate(`/${path}`);
  };

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >
        <BottomNavigation
          showLabels
          value={
            tier1Ativo ? currentPath : maisAberto || outrosAtivo ? "mais" : false
          }
          onChange={(_event, newValue) => {
            if (newValue === "mais") {
              setMaisAberto(true);
            } else if (newValue) {
              handleNavigate(newValue);
            }
          }}
        >
          {tier1.map((item) => {
            const Icon = item.icon;
            return (
              <BottomNavigationAction
                key={item.path}
                label={item.label}
                value={item.path}
                icon={<Icon />}
                sx={{ minWidth: 64, minHeight: 44 }}
              />
            );
          })}
          {outrosItems.length > 0 && (
            <BottomNavigationAction
              label="Mais"
              value="mais"
              icon={<MoreHorizOutlinedIcon />}
              sx={{ minWidth: 64, minHeight: 44 }}
            />
          )}
        </BottomNavigation>
      </Paper>

      <Drawer
        anchor="bottom"
        open={maisAberto}
        onClose={() => setMaisAberto(false)}
      >
        <ListSubheader component="div" sx={{ mt: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Mais opções
          </Typography>
        </ListSubheader>
        <List sx={{ pb: 2 }}>
          {outrosItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === `/${item.path}`;
            return (
              <ListItemButton
                key={item.path}
                selected={active}
                onClick={() => handleNavigate(item.path)}
                sx={{ minHeight: 44 }}
              >
                <ListItemIcon
                  sx={{ color: active ? "primary.main" : "inherit" }}
                >
                  <Icon />
                </ListItemIcon>
                <ListItemText primary={item.fullLabel || item.label} />
              </ListItemButton>
            );
          })}
        </List>
      </Drawer>
    </>
  );
};

export default BottomNav;
